"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _styledComponents = require("styled-components");

var _Axis = _interopRequireDefault(require("./Axis"));

var _AxisLabel = _interopRequireDefault(require("./AxisLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  north: {
    "id": "PolarChart.axisLabel.north",
    "defaultMessage": "Why"
  },
  east: {
    "id": "PolarChart.axisLabel.east",
    "defaultMessage": "What"
  },
  south: {
    "id": "PolarChart.axisLabel.south",
    "defaultMessage": "How"
  },
  west: {
    "id": "PolarChart.axisLabel.west",
    "defaultMessage": "Who When Where"
  }
});

var PolarAxes = function PolarAxes(_ref) {
  var scales = _ref.scales,
      inverted = _ref.inverted,
      show = _ref.show,
      outerLabels = _ref.outerLabels,
      intl = _ref.intl;
  var axes = [];
  var labels = []; // North vertical-axis

  if (show.north) {
    var xScale = show.east ? scales.east : scales.west;
    var label = intl.formatMessage(messages.north);
    axes.push( /*#__PURE__*/_react.default.createElement(_Axis.default, {
      xScale: xScale,
      yScale: scales.north,
      inverted: inverted
    }));
    labels.push( /*#__PURE__*/_react.default.createElement(_AxisLabel.default, {
      xScale: xScale,
      yScale: scales.north,
      label: label,
      outer: outerLabels
    }));
  } // East horizontal-axis


  if (show.east) {
    var yScale = show.north ? scales.north : scales.south;

    var _label = intl.formatMessage(messages.east);

    axes.push( /*#__PURE__*/_react.default.createElement(_Axis.default, {
      xScale: scales.east,
      yScale: yScale,
      horizontal: true,
      inverted: inverted
    }));
    labels.push( /*#__PURE__*/_react.default.createElement(_AxisLabel.default, {
      xScale: scales.east,
      yScale: yScale,
      label: _label,
      horizontal: true,
      outer: outerLabels
    }));
  } // South vertical-axis


  if (show.south) {
    var _xScale = show.west ? scales.west : scales.east;

    var _label2 = intl.formatMessage(messages.south);

    axes.push( /*#__PURE__*/_react.default.createElement(_Axis.default, {
      xScale: _xScale,
      yScale: scales.south,
      inverted: inverted
    }));
    labels.push( /*#__PURE__*/_react.default.createElement(_AxisLabel.default, {
      xScale: _xScale,
      yScale: scales.south,
      label: _label2,
      outer: outerLabels
    }));
  } // West horizontal-axis


  if (show.west) {
    var _yScale = show.south ? scales.south : scales.north;

    var _label3 = intl.formatMessage(messages.west);

    axes.push( /*#__PURE__*/_react.default.createElement(_Axis.default, {
      xScale: scales.west,
      yScale: _yScale,
      horizontal: true,
      inverted: inverted
    }));
    labels.push( /*#__PURE__*/_react.default.createElement(_AxisLabel.default, {
      xScale: scales.west,
      yScale: _yScale,
      label: _label3,
      horizontal: true,
      outer: outerLabels
    }));
  }

  return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, axes), /*#__PURE__*/_react.default.createElement("g", null, labels));
};

PolarAxes.propTypes = {
  scales: _propTypes.default.shape({
    north: _propTypes.default.func.isRequired,
    east: _propTypes.default.func.isRequired,
    south: _propTypes.default.func.isRequired,
    west: _propTypes.default.func.isRequired
  }).isRequired,
  show: _propTypes.default.shape({
    north: _propTypes.default.bool,
    east: _propTypes.default.bool,
    south: _propTypes.default.bool,
    west: _propTypes.default.bool
  }),
  outerLabels: _propTypes.default.bool,
  inverted: _propTypes.default.bool
};
PolarAxes.defaultProps = {
  show: {
    north: true,
    east: true,
    south: true,
    west: true
  },
  outerLabels: false,
  inverted: false
};

var _default = (0, _reactIntl.injectIntl)((0, _styledComponents.withTheme)(PolarAxes));

exports.default = _default;
//# sourceMappingURL=PolarAxes.js.map